import { Service } from '@/request/http.js'

// 获取客服群图片
export function getCode (data) {
  return Service({
    url: '/api/getCode',
    method: 'post',
    params: data
  })
}

// 获取联系方式
export function getContactInfo (data) {
  return Service({
    url: '/api/getContactInfo',
    method: 'post',
    params: data
  })
}

// 联系我们-发送邮件
export function sendContactEmail (data) {
  return Service({
    url: '/api/sendContactEmail',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/question.js